"use client";
export { SliderSlide as default } from "../../../_Builtin/Slider";
